import { render, staticRenderFns } from "./TicketDrawer.vue?vue&type=template&id=a1a3169c&scoped=true"
import script from "./TicketDrawer.vue?vue&type=script&lang=js"
export * from "./TicketDrawer.vue?vue&type=script&lang=js"
import style0 from "./TicketDrawer.vue?vue&type=style&index=0&id=a1a3169c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a3169c",
  null
  
)

export default component.exports